<template>
  <v-btn
    variant="text"
    :icon="true"
    :title="$t('information.selector')"
  >
    <v-icon icon="mdi-information-outline" />
    <v-menu activator="parent" offset-x="2" transition="slide-y-transition">
      <v-list :elevation="24">
        <v-list-item
          :href="manualUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-list-item-title>{{ $t("information.userManual") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-btn>
</template>

<script setup>
const { locale } = useI18n();

const manualUrl = computed(() =>
  locale.value === "en"
    ? "https://acciona365.sharepoint.com/sites/MAP/SitePages/Home.aspx?parenturl=/sites/MAP/Trabajo/2026/03/GMAO_MN0048&docIdioms=2"
    : "https://acciona365.sharepoint.com/sites/MAP/SitePages/Home.aspx?parenturl=/sites/MAP/Trabajo/2026/03/GMAO_MN0048&docIdioms=1"
);
</script>